import script from "./button-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-item.vue?vue&type=script&setup=true&lang=ts"

import "./button-item.vue?vue&type=style&index=0&id=63d9eaa1&lang=scss"
import "./button-item.vue?vue&type=style&index=1&id=63d9eaa1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d9eaa1"]])

export default __exports__